/* BEND — global.js
   Minimal vanilla JS: nav toggle, ingredient tabs, reveal-on-scroll.
   No dependencies. Respects prefers-reduced-motion. */

(function () {
  'use strict';

  /* mobile nav */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }

  /* ingredient tabs */
  document.querySelectorAll('[data-ing-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.ing-tab');
    var panels = root.querySelectorAll('.ing-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.setAttribute('aria-selected', 'true');
        var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* reveal on scroll */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }
})();
